import { accessLogSentence } from '@/features/workspaces/accessLog';
import type { AccessLogEntry } from '@/lib/api/generated/model';

/** Lower-cased with its accents folded away, so "Jose" finds "José". */
function fold(text: string): string {
  return text
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

/**
 * Whether an activity entry matches what was typed (spec 226 research R5):
 * a case- and accent-insensitive substring of the sentence as drawn, the
 * actor's name or their email. Readers search the words they see, so the
 * sentence is `accessLogSentence`, the same one `AccessLogList` prints. An
 * empty needle matches everything.
 */
export function matchesAccessLogEntry(
  entry: AccessLogEntry,
  needle: string,
): boolean {
  const wanted = fold(needle.trim());
  if (wanted === '') return true;
  const haystack = [
    accessLogSentence(entry),
    entry.actor?.display_name ?? '',
    entry.actor?.email ?? '',
  ]
    .map(fold)
    .join('\n');
  return haystack.includes(wanted);
}
